import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IDateRange } from '@app/core/date-range/interfaces/date-range.interface';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { ICombinedLeakScoreChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/interfaces/combined-leak-score-chart-data';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface IFpLoggerNoiseLeakScoreState {
  currentTab: FpLoggerNoiseTabs.LeakScore;
  date: string | null;
  period: MonthsDateRangeType;
  cache: {
    dateRange: IDateRange | null;
    data: ICombinedLeakScoreChartData[] | null;
  };
  popupMainData: ILdLogger | null;
  data: ICombinedLeakScoreChartData[] | null;
  loading: boolean;
  isChartFullscreenActive: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpLoggerNoiseLeakScoreState: IFpLoggerNoiseLeakScoreState = {
  currentTab: FpLoggerNoiseTabs.LeakScore,
  date: null,
  period: MonthsDateRangeType.Six,
  cache: {
    dateRange: null,
    data: null,
  },
  popupMainData: null,
  data: null,
  loading: false,
  isChartFullscreenActive: false,
  error: null,
};
